export {
	CameraUnavailableError,
	canStartRecording,
	MicrophoneUnavailableError,
	type RecorderStatus,
	type RecordingTarget,
	// The imperative discard, for the host that owns the recording's lifetime. The store itself
	// stays unexported: it is written by `recorder-session` alone, and a barrel that handed out
	// `setState` would make that rule unenforceable.
	resetRecording,
	retryUpload,
	type VideoRecordingType,
} from "./recorder-session";
export { isPipSupported } from "./pip-window";
export { RecordingCard, type RecordingCardProps } from "./recording-card";
export { RecordingPanel, type RecordingPanelProps } from "./recording-panel";
export { RecordingPanelHost } from "./recording-panel-host";
export {
	RecordingRecoveryHost,
	type RecordingRecoveryHostProps,
} from "./recording-recovery-host";
export type { RecoverableRecording, RecoveryVerdict } from "./recording-recovery";
export { useRecordingElapsed } from "./use-recording-elapsed";
export { useVideoRecorder, type VideoRecorderController } from "./use-video-recorder";
export { VideoRecorder } from "./video-recorder";
export { VideoRecorderStartModal } from "./video-recorder-start-modal";
